import { Grid } from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import dayjs from 'dayjs';
import { useAlertsFilters } from './hook';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { AlertFiltersProps } from './props';
import { Checkbox } from '../../../../components/general/fields/checkbox';
import { formatParams } from '../../../../../shared/utils/params';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';

export const AlertsFilters = ({ onFilter, loading }: AlertFiltersProps) => {
    const {
        formik,
        typesDocument,
        typesReceivedThrough,
        typesReceptionChannel,
        typesTypePqr,
        typesSubtypeDp,
        typesTransaction,
    } = useAlertsFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nº de regla"
                    name="ruleNumber"
                    size="small"
                    touched={formik.touched.ruleNumber}
                    errors={formik.errors.ruleNumber}
                    value={formik.values.ruleNumber as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación inicial"
                    name="startCreatedAt"
                    size="small"
                    maxDate={dayjs()}
                    touched={formik.touched.startCreatedAt}
                    errors={formik.errors.startCreatedAt?.toString()}
                    value={formik.values.startCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('startCreatedAt', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación final"
                    name="endCreatedAt"
                    size="small"
                    maxDate={dayjs()}
                    touched={formik.touched.endCreatedAt}
                    errors={formik.errors.endCreatedAt?.toString()}
                    value={formik.values.endCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('endCreatedAt', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesDocument)}
                    label="Estado"
                    name="status"
                    size="small"
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('status', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesDocument)}
                    label="Nuevo estado PQR"
                    name="newStatus"
                    size="small"
                    touched={formik.touched.newStatus}
                    errors={formik.errors.newStatus}
                    value={formik.values.newStatus as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('newStatus', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesReceptionChannel)}
                    label="Canal de recepción"
                    name="receptionChannel"
                    size="small"
                    touched={formik.touched.receptionChannel}
                    errors={formik.errors.receptionChannel}
                    value={formik.values.receptionChannel as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('receptionChannel', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesTypePqr)}
                    label="Tipo PQR"
                    name="typePQR"
                    size="small"
                    touched={formik.touched.typePQR}
                    errors={formik.errors.typePQR}
                    value={formik.values.typePQR as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typePQR', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesReceivedThrough)}
                    label="Medio"
                    name="receivedThrough"
                    size="small"
                    touched={formik.touched.receivedThrough}
                    errors={formik.errors.receivedThrough}
                    value={formik.values.receivedThrough as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('receivedThrough', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesSubtypeDp)}
                    label="Subtipo DP"
                    name="subtypeDP"
                    size="small"
                    touched={formik.touched.subtypeDP}
                    errors={formik.errors.subtypeDP}
                    value={formik.values.subtypeDP as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('subtypeDP', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesTransaction)}
                    label="Trámite"
                    name="transaction"
                    size="small"
                    touched={formik.touched.transaction}
                    errors={formik.errors.transaction}
                    value={formik.values.transaction as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('transaction', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
